<template>
  <div>
    <b-modal
      :scrollable="false"
      id="edit-employee-store"
      ref="modal"
      header-class="headerModal"
      centered
      :title="$t('EditToStore')"
      hide-footer
      @close="onReset"
    >
      <b-form>
        <b-form-group :label="`${$t('Stores')}:`">
          <vue-select
            id="input-5"
            v-model="storeId"
            :options="filteredStores"
            label="storeName"
            :placeholder="$t('SelectStore')"
          />
        </b-form-group>
        <div class="buttonsEverywhere">
          <button
            type="button"
            class="buttonSubmit"
            variant="none"

            @click="onSubmit"
          >
            {{ $t('Submit') }}
          </button>
          <b-button
            type="button"
            variant="danger"
            class="buttonCancel"

            style="margin-right: 15px; background: white; color: black; border-color: white;font-weight: 400;"

            @click="onReset"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';
// import { required, minLength } from 'vuelidate/lib/validators';

export default {
  mixins: [validationMixin],
  props: ['userId', 'editEmployeeStoreDetails'],
  data() {
    return {
      storeId: {
        storeId: null,
        storeName: 'No filiale',
        storeGLN: null,
      },
    }
  },
  computed: {
    ...mapGetters(['getAllStoresDropdown']),
    filteredStores() {
      const filteredStores = this.getAllStoresDropdown.filter((store) => {
        return store.storeName !== 'all' && store.storeName !== 'unassigned'
      });

      const allOption = { storeId: null, storeName: 'No filiale', storeGLN: null };
      const unassigned = { storeId: '00000000-0000-0000-0000-000000000000', storeName: 'Unassigned', storeGLN: null };
      return [allOption, unassigned, ...filteredStores];
    },
  },
  watch: {
    editEmployeeStoreDetails(value) {
      this.storeId = {
        storeId: value.storeId.toUpperCase(),
        storeName: value.storeName,
        storeGLN: null,
      }
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions([
    ]),
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const form = {
        storeId: this.storeId.storeId,
        userId: this.userId,
      };
      this.$emit('editEmpStore', form);
      this.$refs.modal.hide();
      this.onReset();
    },
    onReset() {
      this.storeId = {
        storeId: this.editEmployeeStoreDetails.storeId.toUpperCase(),
        storeName: this.editEmployeeStoreDetails.storeName,
        storeGLN: null,
      }
      this.$refs.modal.hide();
      setTimeout(() => { this.$v.$reset() }, 0)
      this.$nextTick(() => { this.$v.$reset() })
    },
  },
};
</script>

  <style lang="scss" scoped>
  form {
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }

  .flex-form {
    display: flex;
    flex-direction: column;
  }

  .form-group {
    margin-bottom: 10px;
  }
  </style>
